import { useState } from 'react'

import Image from 'next/image'
import { ExpandMenu } from '../Global/ExpandMenu'
import { DropdownMenu } from '../Global/DropdownMenu/DropdownMenu'
import { MenuItem } from '../Global/DropdownMenu/MenuItem'
import { Button } from 'components/Global/Button'
import { CartButton } from 'components/Global/Cart/CartButton'
import { SearchButton } from 'components/Global/Search/SearchButton'
import { urlForImage } from 'lib/sanity.image'

const Dropdown = ({ label, links, className = '' }) => {
  return (
    <DropdownMenu label={label} className={className}>
      {links.map((link) => {
        return (
          <MenuItem
            label={link.label}
            key={link._key}
            href={
              link.to?.store
                ? `/${link.to._type}s/${link.to?.store?.slug?.current}`
                : ''
            }
          />
        )
      })}
    </DropdownMenu>
  )
}

const ExpandableMenu = ({ label, links, expanded, setExpanded, ...rest }) => {
  return (
    <ExpandMenu
      label={label}
      expanded={expanded}
      updateExpanded={setExpanded}
      className="mr-8 p-2"
      {...rest}
    >
      {links.map((link, index) => {
        const className = index === 0 ? 'p-4' : 'ml-4 p-4'
        switch (link._type) {
          case 'dropdown':
            return (
              <Dropdown
                key={link._key}
                label={link.label}
                links={link.links}
                className={className}
              />
            )
          case 'link':
            return (
              <Link
                key={link._key}
                label={link.label}
                to={link.to}
                styled={false}
                className={className}
              />
            )
          default:
            return null
        }
      })}
    </ExpandMenu>
  )
}

const Link = ({
  label,
  to,
  styled = true,
  className = '',
  stretch = false,
}) => {
  return (
    <div
      className={`main-nav-link ${
        styled ? 'background-blur rounded-8 leading-[13px]' : ''
      } ${className}`}
    >
      <Button
        href={
          to.store
            ? `/${to._type}s/${to.store.slug.current}`
            : `/${to.slug.current}`
        }
        className={`py-[10px] ${
          stretch ? 'flex items-center self-stretch' : ''
        }`}
      >
        {label}
      </Button>
    </div>
  )
}

export const HeaderDesktop = ({ menu, logo, withBanner = false }) => {
  const [expanded, setExpanded] = useState(false)

  const mouseEnter = () => {
    setExpanded(true)
  }

  const mouseLeave = (e) => {
    setExpanded(false)
  }

  return (
    <header
      className={`fixed ${
        withBanner ? 'top-[20px]' : 'top-0'
      } z-10 hidden w-full justify-between p-20 text-11 leading-110 text-darkGray md:flex`}
    >
      <div className="flex" onMouseLeave={mouseLeave}>
        <div className="background-blur flex items-stretch rounded-8">
          <Button className="flex items-center justify-center" href="/">
            <Image
              src={urlForImage(logo).width(100).auto('format').url()}
              width={53}
              height={10}
              alt="Chnge Logo"
            />
          </Button>
        </div>
        {menu.map((item) => {
          switch (item._type) {
            case 'dropdown':
              return (
                <Dropdown
                  key={item._key}
                  label={item.label}
                  links={item.links}
                />
              )
            case 'expandableMenu':
              return (
                <ExpandableMenu
                  key={item._key}
                  label={item.label}
                  links={item.links}
                  expanded={expanded}
                  setExpanded={setExpanded}
                  onMouseEnter={mouseEnter}
                />
              )
            case 'link':
              return (
                <Link
                  key={item._key}
                  label={item.label}
                  to={item.to}
                  className="mr-8 flex items-center"
                  stretch
                />
              )
            case 'default':
              return null
          }
          return <div key={item._key}>{item._type}</div>
        })}
      </div>
      <div className="relative flex">
        <SearchButton />
        <CartButton />
      </div>
    </header>
  )
}
